import React from 'react';
import { string, oneOf, node } from 'prop-types';
import ClassNames from 'classnames';

import './MessagePrompt.scss';

const typesModifier = {
  default: '--default',
  positive: '--positive',
  warm: '--warm',
  negative: '--negative',
  muted: '--muted'
};

const MessagePrompt = ({ className, children, type }) => (
  <div
    className={ClassNames(
      'message-prompt --px-sm --py-xs',
      `message-prompt${typesModifier[type]}`,
      className
    )}
  >
    {children}
  </div>
);

MessagePrompt.propTypes = {
  className: string,
  children: node.isRequired,
  type: oneOf(['default', 'positive', 'warm', 'negative', 'muted'])
};

MessagePrompt.defaultProps = {
  className: undefined,
  type: 'default'
};

export default MessagePrompt;
